export function handleFullscreenMedia() {
    const fullscreenMedias = document.querySelectorAll(".pul-fullscreen-media__video");

    if(fullscreenMedias.length > 0) {
        for(const media of fullscreenMedias) {
            const video = media.querySelector("video");
            const button = media.querySelector("button");

            button.addEventListener("click", () => {
                if(video.paused) {
                    video.setAttribute("controls", "");
                    video.play();
                    button.classList.add("playing");
                }
            });

            video.addEventListener("ended", () => {
                video.removeAttribute("controls");
                video.pause();
                button.classList.remove("playing");
            });

            video.addEventListener("click", () => {
                video.removeAttribute("controls");
                video.pause();
                button.classList.remove("playing");
            });
        }
    }
}